import React from 'react';
import { Box, Typography } from '@mui/material';
import GridContainer from 'components/shared/GridContainer';
import GridItem from 'components/shared/GridItem';
import Card from 'components/shared/Card';
import { WithdrawalType } from 'store/enums/BallotReviewTypes';
import { Reject } from 'store/types/Meeting';
import { getFormattedDate } from 'util/format';
import { withdrawalTypeLabel } from 'util/meeting';

interface RejectViewCardProps {
  reject: Reject;
}

const RejectViewCard: React.FunctionComponent<RejectViewCardProps> = ({ reject }) => {
  return (
    <Card title={<Typography variant="h6">Reject</Typography>} bordered>
      <GridContainer spacing={1}>
        <GridItem md={2}>
          <Typography>
            <strong>Reject Affiliate:</strong>
          </Typography>
        </GridItem>
        <GridItem md={10}>
          <Typography>{reject.votingInterest}</Typography>
        </GridItem>

        <GridItem md={2}>
          <Typography>
            <strong>Rejected By:</strong>
          </Typography>
        </GridItem>
        <GridItem md={10}>
          <Typography>{reject.rejectedBy}</Typography>
        </GridItem>

        <GridItem md={2}>
          <Typography>
            <strong>Negative Referenced Section/Paragraph:</strong>
          </Typography>
        </GridItem>
        <GridItem md={10}>
          <Typography>{reject.reference}</Typography>
        </GridItem>

        <GridItem md={2}>
          <Typography>
            <strong>Negative Text:</strong>
          </Typography>
        </GridItem>
        <GridItem md={10}>
          <Box sx={{ typography: 'body1' }} dangerouslySetInnerHTML={{ __html: reject.text ?? '' }} />
        </GridItem>

        {reject.taskForceInput && (
          <>
            <GridItem md={2}>
              <Typography>
                <strong>TF input:</strong>
              </Typography>
            </GridItem>
            <GridItem md={10}>
              <Typography>{reject.taskForceInput}</Typography>
            </GridItem>
          </>
        )}

        {reject.withdrawal && (
          <>
            <GridItem md={2}>
              <Typography>
                <strong>Withdrawal:</strong>
              </Typography>
            </GridItem>
            <GridItem md={10}>
              <Typography>{`${withdrawalTypeLabel[reject.withdrawal]} ${
                reject.withdrawal === WithdrawalType.WithdrawalMade
                  ? `on ${getFormattedDate(reject.withdrawalDate ?? '', 'L')}`
                  : ''
              }`}</Typography>
            </GridItem>
          </>
        )}
      </GridContainer>
    </Card>
  );
};

export default RejectViewCard;
